import { render, staticRenderFns } from "./team.vue?vue&type=template&id=220bd9d4&scoped=true&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"
import style0 from "../less/profileSettings.less?vue&type=style&index=0&id=220bd9d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bd9d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('220bd9d4')) {
      api.createRecord('220bd9d4', component.options)
    } else {
      api.reload('220bd9d4', component.options)
    }
    module.hot.accept("./team.vue?vue&type=template&id=220bd9d4&scoped=true&", function () {
      api.rerender('220bd9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/pages/team.vue"
export default component.exports